import { Component } from "@angular/core";

@Component({
  standalone: true,
  selector: "hls-not-found",
  templateUrl: "not-found.html",
})
export class NotFound {}
